import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaUser } from "react-icons/fa";
import Cookies from 'js-cookie';

const Navbar = () => {
    const [showPopUp, setshowPopUp] = useState(false);
    const navigate = useNavigate();
    const popUpRef = useRef(null);

    const ShowPopUp = () => {
        setshowPopUp(!showPopUp);
    }

    const logOut = () => {
        localStorage.removeItem("role");
        Cookies.remove('jwt_token');
        navigate('/super-admin');
    }

    const handleClickOutside = (event) => {
        if (popUpRef.current && !popUpRef.current.contains(event.target)) {
            setshowPopUp(false);
        }
    }

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <nav className="bg-gray-800 p-4">
            <div className="container mx-auto flex justify-between items-center">
                <div className="text-white text-lg font-bold">
                    <a href='/super-admin/dashboard'>
                        <img src="https://www.inclineanalytics.com/wp-content/uploads/2020/04/Incline-Analytics5-01.png" alt="Incline Analytics Logo" style={{ width: "80px", height: "auto" }} />
                    </a>
                </div>
                <div className="flex items-center">
                    <div className="ml-4 relative">
                        <button onClick={ShowPopUp} className="p-3 text-2xl text-[#ffffff] border border-[#ff6f61] hover:shadow-custom-orange p-2 rounded-full focus:outline-none focus:shadow-outline ">
                            <FaUser />
                        </button>
                        {showPopUp &&
                            <div ref={popUpRef} className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5">
                                <button onClick={logOut} className="block w-full px-4 py-2 text-sm text-gray-700">Sign out</button>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
